import {z} from '@hono/zod-openapi';

/**
 * The signed-link query. `passthrough` because the signature is computed over every declared
 * parameter the caller sent, so the undeclared ones have to survive validation.
 */
export const priceReportFromLinkQuerySchema = z.object({hash: z.string().optional()}).passthrough();
